var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63867 19V18C3.63867 15.7909 5.42953 14 7.63867 14H11.6387C13.8478 14 15.6387 15.7909 15.6387 18V19M15.6387 11C17.2955 11 18.6387 9.65685 18.6387 8C18.6387 6.34315 17.2955 5 15.6387 5M21.6387 19V18C21.6387 15.7909 19.8478 14 17.6387 14H17.1387M12.6387 8C12.6387 9.65685 11.2955 11 9.63867 11C7.98182 11 6.63867 9.65685 6.63867 8C6.63867 6.34315 7.98182 5 9.63867 5C11.2955 5 12.6387 6.34315 12.6387 8Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsactiveIcon);
export default __webpack_public_path__ + "static/media/teamsactiveIcon.edf44f485abdc6bfdf41a4b22b709cc3.svg";
export { ForwardRef as ReactComponent };